
import React from 'react';
import ClassAssembly  from 'views/ClassAssembly2C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;